import {z} from 'zod';

export const purgeQueueResponseSchema = z.object({
  status: z.string(),
  message: z.string(),
  timestamp: z.string(),
});
